<template>
  <TheLayout>
    <div class="inventory-checkout" v-if="dataPermission && dataPermission.includes('NSH_ODM_CO_VIEW')">
      <div class="page-title title">
        <span>XUẤT KHO</span>
      </div>

      <div v-if="isShow">
        <div class="main-content-layout data-none">
          <div>
            <h1 class="title-no-data">Chưa có đơn xuất kho nào</h1>
            <!-- <div class="button-create-inventory">
              <router-link to="/storage-create">
                <BaseButton>Tạo đơn xuất kho</BaseButton>
              </router-link>
            </div> -->
          </div>
        </div>
      </div>

      <div class="full-width" style="background: #fff; padding: 20px;" v-else>
        <loading v-if="loading"></loading>
        <div style="width: inherit;">
          <div style="margin-bottom:24px" class="row px-3 d-flex justify-content-between">
            <div style="align-items: flex-end;" class="d-flex justify-content-between">
              <el-popover
              class="mr-3"
              v-model="filterModal"
              placement="bottom-start"
              width="90vw"
              trigger="click">
                <el-button class="n-btn" type="info" slot="reference">
                  <div class="n-icon">
                    <i class="mdi mdi-filter-outline"></i> Bộ lọc 
                  </div>
                </el-button>

                <!-- Bộ lọc -->
                <div class="d-flex justify-content-between">
                  <div class="filter-list">
                    <div class="my-2">
                      <multiselect
                      v-model="valueTypeOrder"
                      placeholder="Loại đơn"
                      :showLabels= false
                      label="text"
                      track-by="id" :options="checkoutType" :multiple="true"
                      ></multiselect>
                    </div>

                    <div class="my-2">
                      <el-select
                      placeholder="Kho xuất"
                      class="el"
                      v-model="checkoutID">
                        <el-option
                          v-for="item in inventoryCheckout"
                          :key="item.id"
                          :label="item.text"
                          :value="item.id"
                          >
                        </el-option>
                      </el-select>
                    </div>

                    <div class="my-2 d-flex">
                      <el-select
                      placeholder="Trạng thái đơn"
                      class="el w-100 mr-2"
                      v-model="statusCheckout">
                        <el-option
                          v-for="item in processorStatus"
                          :key="item.id"
                          :label="item.text"
                          :value="item.id"
                          >
                        </el-option>
                      </el-select>
                      <el-select
                      placeholder="Người tạo"
                      class="el w-100"
                      v-model="creator">
                        <el-option
                          v-for="item in listCreater"
                          :key="item.id"
                          :label="item.text"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                
                    <div class="my-2 d-flex">
                      <div class="w-25 mt-2 mr-2 text-right">Ngày tạo: </div>
                      <el-date-picker
                        class="el w-75"
                        type="daterange"
                        align="right"
                        start-placeholder="Từ ngày"
                        end-placeholder="Đến ngày"
                        format="dd/MM/yyyy"
                        v-model="dateRange"
                        :clearable="false">
                      </el-date-picker>
                    </div>
                  </div>
                </div>
                  <div class="d-flex justify-content-end">
                    <el-button class="n-btn" @click="filterModal = false">Huỷ</el-button>
                    <el-button class="n-btn" type="danger" plain @click="removeFilter"
                    v-if="valueTypeOrder != [] || checkoutID != '' || statusCheckout != '' || creator != '' || dateRange[0]">Xóa bộ lọc</el-button>
                    <el-button class="n-btn" type="primary" @click="searching"
                    v-if="valueTypeOrder != [] || checkoutID != '' || statusCheckout != '' || creator != '' || dateRange[0]">Áp dụng bộ lọc</el-button>
                  </div>
                </el-popover>
                <div>
                  <el-input @keyup.enter.native="searching" v-model="search.textSearch" style="width:340px" placeholder="Tìm kiếm" clearable>
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                </div>
              </div>
              <div>
              </div>
            </div>
            <div>
              <div style="max-width: 100%; width: 100%;">
                <LayoutTable :fields="fieldInventory.filter(e => e.show)" :items="itemInventory">
                  <template #header-edit>
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style="cursor: pointer"
                      @click="showPopup('Cai-dat-hien-thi'), (visibleEditShow = true)"
                    >
                      <path
                        d="M6.16016 9.50391C6.85449 9.50391 7.4082 8.9502 7.4082 8.25586C7.4082 7.57031 6.85449 7.00781 6.16016 7.00781C5.47461 7.00781 4.91211 7.57031 4.91211 8.25586C4.91211 8.9502 5.47461 9.50391 6.16016 9.50391ZM10.291 9.09961H22.2266C22.7012 9.09961 23.0791 8.73047 23.0791 8.25586C23.0791 7.78125 22.71 7.41211 22.2266 7.41211H10.291C9.8252 7.41211 9.44727 7.78125 9.44727 8.25586C9.44727 8.73047 9.81641 9.09961 10.291 9.09961ZM6.16016 14.9092C6.85449 14.9092 7.4082 14.3555 7.4082 13.6611C7.4082 12.9756 6.85449 12.4131 6.16016 12.4131C5.47461 12.4131 4.91211 12.9756 4.91211 13.6611C4.91211 14.3555 5.47461 14.9092 6.16016 14.9092ZM10.291 14.5049H22.2266C22.7012 14.5049 23.0791 14.1357 23.0791 13.6611C23.0791 13.1865 22.71 12.8174 22.2266 12.8174H10.291C9.8252 12.8174 9.44727 13.1865 9.44727 13.6611C9.44727 14.1357 9.81641 14.5049 10.291 14.5049ZM6.16016 20.3145C6.85449 20.3145 7.4082 19.7607 7.4082 19.0664C7.4082 18.3809 6.85449 17.8184 6.16016 17.8184C5.47461 17.8184 4.91211 18.3809 4.91211 19.0664C4.91211 19.7607 5.47461 20.3145 6.16016 20.3145ZM10.291 19.9102H22.2266C22.7012 19.9102 23.0791 19.541 23.0791 19.0664C23.0791 18.5918 22.71 18.2227 22.2266 18.2227H10.291C9.8252 18.2227 9.44727 18.5918 9.44727 19.0664C9.44727 19.541 9.81641 19.9102 10.291 19.9102Z"
                        fill="#888888"
                      />
                    </svg>
                  </template>
                  <template #cell-orderNo="{ data: item }">
                    <div @click="linkTo(item.id)" style="cursor: pointer">
                      {{ item.orderNo }}
                    </div>
                  </template>
                  <template #cell-processorStatusText="{ data: item }">
                    <base-tag :type="item.processorStatusDisplay.color">{{ item.processorStatusDisplay.text }}</base-tag>
                  </template> 
                </LayoutTable>
              </div>
            </div>
            <div class="pagination-wrapper">
              <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="search.pageSize"
              ></b-pagination>
            </div>
            <ItemArrangeColumn v-model="fieldInventory" />
        </div>
      </div>
    </div>
    <NotPermission v-else></NotPermission>
  </TheLayout>
</template>
<script>
import { formatHHmmDDMMYYYY } from "../../utils/format";
import { statusCheckInStorage } from "../../utils/mapping";
import VueCookies from "vue-cookies";
import ItemArrangeColumn from "@/pages/items/components/ItemArrangeColumn.vue";
import { InventoryService } from "@/services/nextshop/inventory.service.js";
import { EmployeeService } from "@/services/nextshop/employee.service";
import moment from "moment";
export default {
  components: {
    ItemArrangeColumn,
  },
  data () {
    return {
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      coMerchantId: JSON.parse(localStorage.getItem("auth.currentMerchant")).id,
      isShow: false,
      loading: false,
      filterModal: false,
      visibleEditShow: true,
      fieldInventory: [
        {
          label: "Mã phiếu",
          key: "orderNo",
          show: true
        },
        {
          label: "Mã kho xuất",
          key: "checkoutInventoryId",
          show: false
        },
        {
          label: "Kho xuất",
          key: "checkoutInventoryName",
          show: true
        },
        {
          label: "Mã chi nhánh xuất",
          key: "locationIdCheckout",
          show: false
        },
        {
          label: "Chi nhánh xuất",
          key: "locationNameCheckout",
          show: false
        },
        {
          label: "Tổng số mặt hàng",
          key: "totalVariation",
          show: false
        },
        {
          label: "Tổng số sản phẩm",
          key: "totalItem",
          show: false
        },
        {
          label: "Người tạo",
          key: "creator",
          show: true,
        },
        {
          label: "Trạng thái đơn",
          key: "processorStatusText",
          show: true,
        },
        {
          label: "Thời gian tạo",
          key: "createdAt",
          show: true,
        },
        {
          label: "Thời gian cập nhật",
          key: "updatedAt",
          show: true,
        },
        {
          key: "edit",
          label: "",
          thClass: "text-right",
          show: true,
        },
      ],
      search: {
        queryString: "",
        sortBy: "id",
        sortType: "DESC",
        pageNum: "1",
        pageSize: "20",
        textSearch: "",
      },
      currentPage: 1,
      rows: 450,
      itemInventory: [],
      valueTypeOrder: [
        { text: 'Đơn xuất điều chuyển', id: 'TRANSFER' }
      ],
      checkoutType: [
        { text: 'Đơn xuất điều chuyển', id: 'TRANSFER' },
        { text: 'Đơn xuất bán hàng', id: 'SALE' }
      ],
      checkoutID: "",
      inventoryCheckout: [],
      listLocation: [],
      creator: "",
      listCreater: [],
      statusCheckout: "",
      processorStatus: [
        { id: "DRAFT", text: "Nháp" },
        { id: "SUCCESS", text: "Hoàn thành" },
        { id: "CANCELED", text: "Đã hủy" },
      ],
      dateRange: {},
    }
  },
  async created () {
    await this.checkConfigInventory()
    this.listCheckout()
    this.getListCreater()
    this.fetchData()
  },
  watch: {
    currentPage() {
      this.listInventoryCheckout({ ...this.search, pageNum: this.currentPage });
    },
  },
  computed: {
    hideIcon() {
      return this.search.textSearch.length != 0;
    },
    fieldsSelect() {
      return this.fieldInventory.filter((fil) => fil.label);
    },
    draggingInfo() {
      return this.dragging ? "" : "";
    }
  },
  methods: {
    // chuyển trang chi tiết đơn nhập
    linkTo(id) {
      this.$router.push(`storage-export/detail/${id}`);
    },
    // checkoutInventory
    async listInventoryCheckout(params) {
      try {
        const data = await InventoryService.checkoutInventory(params)
        if (data.success) {
          this.rows = data.data.totalElements;
          this.itemInventory = data.data.data.map((e) => {
            return {
              id: e.id,
              orderNo: e.orderNo, // mã đơn
              checkoutInventoryId: e.lineItem[0].lineItemOtherInfo.fromInventoryId, // id kho xuất
              checkoutInventoryName: e.lineItem[0].lineItemOtherInfo.fromInventoryName != null ? e.lineItem[0].lineItemOtherInfo.fromInventoryName : '', // tên kho xuất
              totalVariation: e.lineItem.length, // tổng số mặt hàng
              totalItem: e.lineItem.reduce((a, b) => { return a + b.quantity }, 0), // tổng SL xuất kho
              creator: e.furtherInstructions[0].params ? e.furtherInstructions[0].params.employeeName : "", // người tạo
              locationIdCheckout: e.locationToCreate, // id chi nhánh xuất
              locationNameCheckout: this.getNameLocation(e.locationToCreate), // tên chi nhánh xuất
              processorStatusText: statusCheckInStorage(e.processorStatus).text, // trạng thái
              processorStatusDisplay: statusCheckInStorage(e.processorStatus),
              createdAt: formatHHmmDDMMYYYY(e.createdAt), // ngày tạo đơn
              updatedAt: formatHHmmDDMMYYYY(e.updatedAt) // thời gian update đơn lần cuối
            }
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    async fetchData (){
      this.search.queryString = "({furtherInstructions.params.sourceAction} == '''TRANSFER''')"
      await this.listInventoryCheckout(this.search)
    },
    // lọc
    async searching() {
      this.currentPage = 1
      const queryArray = []
      // loại kho xuất
      const valueTypeOrderId = this.valueTypeOrder.map(e => e.id)
      if (valueTypeOrderId.length != 0) {
        const ar = []
        valueTypeOrderId.forEach(val => ar.push("{furtherInstructions.params.sourceAction} == '''" + val +"'''"))
        ar.length > 1 ? queryArray.push("(" + ar.join(" or ") + ")") : queryArray.push(ar[0])
      }
      // kho xuất
      if (this.checkoutID != "") {
        queryArray.push("{lineItem.lineItemOtherInfo.fromInventoryId} =='''" + this.checkoutID + "'''")
      }
      // trạng thái đơn
      if (this.statusCheckout != "") {
        queryArray.push("{processorStatus} =='''" + this.statusCheckout + "'''");
      }
      // ng tạo
      if (this.creator != "") {
        queryArray.push("{furtherInstructions.params.employeeId} =='''" + this.creator + "'''");
      }
      // ngày tạo
      if (this.dateRange[0] != undefined || this.dateRange[1] != undefined) {
        queryArray.push(
          "{createdAt} >= #" +
            `${moment(this.dateRange[0]).format("YYYY-MM-DD")}` +
            `T00:00:00.000Z# and {createdAt} <= #` +
            `${moment(this.dateRange[1]).format("YYYY-MM-DD")}` +
            "T23:59:59.000Z#"
        );
      }
      this.search.queryString = queryArray.join(" and ");
      this.search.textSearch = this.search.textSearch.trim()
      this.filterModal = false;
      await this.listInventoryCheckout(this.search);
    },
    // xoá bộ lọc
    async removeFilter() {
      this.checkoutID = ""
      this.statusCheckout = ""
      this.creator = ""
      this.dateRange = {}
      this.valueTypeOrder = [
        { text: 'Đơn xuất điều chuyển', id: 'TRANSFER' }
      ]
      this.filterModal = false
      await this.listInventoryCheckout({
        queryString: "({furtherInstructions.params.sourceAction} == '''TRANSFER''')",
        sortBy: "id",
        sortType: "DESC",
        pageNum: "1",
        pageSize: this.search.pageSize,
      })
    },
    // danh sách kho xuất
    async listCheckout() {
      try {
        const data = await InventoryService.inventoryListUser({
          merchantId: this.coMerchantId,
          appId: '5e86f1882c185a6b907057c1',
          userId: JSON.parse(localStorage.getItem("auth.currentUser")).userId
        })
        if (data.success) {
          this.listLocation = data.data.map(e => e.coLocationId)
          const lC = []
          const params = {
            coMerchantId: this.coMerchantId,
            typeInventory: "NSH_ITEM_SALE",
            textSearch: '',
            page: 1,
            limit: 20
          }
          for (let i in this.listLocation) {
            params.coLocationId = this.listLocation[i]
            const data = await InventoryService.inventorylist(params)
            if (data.success) {
              lC.push(data.data[0])
            }
          }
          this.inventoryCheckout = lC.map(e => {
            return {
              id: e.coInventoryId,
              text: e.name
            }
          })
        }
      }
      catch (error) {
        console.log(error)
      }
    },
    // danh sách người tạo
    async getListCreater() {
      try {
        const data = await EmployeeService.listEmployeeLocation({
          merchantId: this.coMerchantId,
          locationId: VueCookies.get("LID"),
          userType: JSON.parse(localStorage.getItem("auth.currentUser")).role
        });
        if (data.success) {
          this.listCreater = data.data.map((e) => {
            return {
              id: e.coAliasUserId,
              text: e.name,
            };
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
}
</script>

<style lang="scss">
  .search-input input{
      height: 44px;
  }
</style>

<style lang="scss" scoped>
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
}
.inventory-checkout {
  .input-search {
    top: 0;
    width: 300px;
    padding: 0 0 10px 0;
  }
  .title {
    padding-bottom: 18px;
  }
}

.filter-list {
  // display: inline-block;

  .storage-select {
    float: left;
    min-width: 150px;
  }
}

.data-none {
  padding: 24px;
  display: flex;
  justify-content: center;
  .title-no-data {
    font-size: 14px !important;
    padding-bottom: 16px;
  }
  .button-create-inventory {
    display: flex;
    justify-content: center;
  }
}

.btn-filter {
  padding: 8px;
  display: flex;
  justify-content: flex-start;
  :first-child {
    margin-right: 10px;
  }
}

::v-deep .__input_wrap {
  background: #f2f2f2;
  padding: 8px !important;
  .__input_controls {
    background: #f2f2f2;
  }
  input.__input {
    background: #f2f2f2;
  }
  .__input::placeholder {
    color: #666666;
  }
  :last-child {
    padding: 0;
  }
}

::v-deep .el {
  background: #f2f2f2;
  i {
    color: #666666;
  }
  input {
    background: #f2f2f2;
  }
  input::placeholder {
    color: #666666;
  }
}

::v-deep table {
  tbody {
    tr {
      td {
        word-break: break-word;
      }
    }
  }
}

@media screen and(max-width: 767px) {
  .inventory-checkin {
    .header {
      display: block;
    }
    .storage-select {
      margin-bottom: 10px;
    }
  }
}
</style>
